import { createSelector } from 'reselect'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'

const isGroupPaymentShareCheckout = createSelector(
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (postPurchase): boolean => postPurchase === 'group-payment-share',
)

export default isGroupPaymentShareCheckout
